import { getAppVariable } from '@white-label-helper/get-app-variable';
import type { POI } from '@white-label-types/parking-booking';
import { AirportMixin } from './get-airport';

const getAirport: AirportMixin= {
  computed: {
    airport(): { code: string; name: string } {
      const airportCode = this.product?.search_criteria?.[this.product?.product_code]?.airport_code || this.product?.locationInfo?.code;
      const airport = getAppVariable('pois').find(
        (poi: POI) => poi.code === airportCode
      );
      let name = '';
      let code = '';
      if (airport) {
        if (airport.code === 'BFS') {
          name = 'Belfast International';
        } else if (airport.code === 'LCY') {
          name = 'London City';
        } else {
          name = airport.name
            .replace(/International|Airport|London/g, '')
            .trim();
        }
        code = airport.code;
      }
      return { code, name };
    },
  },

};

export default getAirport;
